const copyIntoTarget = (text, target_selector) => {
  const selector = $(target_selector);
  const new_text = text.length || !selector.data('default') ? text : selector.data('default');
  selector.html(new_text);
};

const setListener = (selector) => {
  $(selector).on('keyup', (e) => {
    const element = $(e.target);
    copyIntoTarget(element.val(), element.data('mirror-target'));
  });
};

const init = (selector) => {
  try {
    if (selector) {
      setListener(selector);
    }
  } catch (e) {
    console.error(e);
  }
};

window.MirrorInput = {
  init: init,
};
